import { render, staticRenderFns } from "./PostReview.vue?vue&type=template&id=79e3c255"
import script from "./PostReview.vue?vue&type=script&lang=js"
export * from "./PostReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports